// PA-3b — read-only banner shown while a TOC platform-staff member is viewing a tenant.
// Purely presentational; the API enforces read-only server-side (platformStaffGuard).
import React from 'react'

// DEF-80c — `acting`: a platform admin working inside the restaurant with owner-level access. A distinct,
// alarming colour so it is never mistaken for the restaurant's own session.
export function StaffBanner({
  restaurantName,
  onSwitch,
  acting = false,
}: {
  restaurantName: string
  onSwitch: () => void
  acting?: boolean
}) {
  return (
    <div role="status" style={acting ? { ...styles.bar, ...styles.acting } : styles.bar}>
      {acting ? (
        <span>
          You are acting in <strong>{restaurantName}</strong> as <strong>TOC Admin</strong> — full access; every
          change is recorded.
        </span>
      ) : (
        <span>
          Viewing <strong>{restaurantName}</strong> as Tables&nbsp;of&nbsp;Content platform staff —{' '}
          <strong>read-only</strong>.
        </span>
      )}
      <button type="button" onClick={onSwitch} style={styles.btn}>
        Switch restaurant
      </button>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    background: '#1e293b',
    color: '#fff',
    padding: '8px 16px',
    fontFamily: 'system-ui, sans-serif',
    fontSize: 14,
  },
  btn: {
    background: '#334155',
    color: '#fff',
    border: '1px solid #475569',
    borderRadius: 6,
    padding: '4px 12px',
    cursor: 'pointer',
    fontSize: 13,
    whiteSpace: 'nowrap',
  },
  acting: { background: '#991b1b' },
}
